// extracted by mini-css-extract-plugin
module.exports = {"chipRoot":"render-colored-icon-tags_chipRoot__3N_OD","chipAvatar":"render-colored-icon-tags_chipAvatar__TWjSn","chipDeleteIcon":"render-colored-icon-tags_chipDeleteIcon__2nnI2"};